// import hotkeys from "hotkeys-js"

window.IntumJs = {
  toggle: function(...targetIds) {
    targetIds.forEach(targetId => {
      const target = document.getElementById(targetId)
      if (target) {
        target.classList.toggle("hidden")
      }
    })
    return false
  },

  slugify: function(text) {
    return text
      .toLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "")
  },

  // focus textarea and position cursor at end of specified line (1-indexed)
  focusAtEndOfLine: function(elementId, lineNumber) {
    const el = document.getElementById(elementId)
    if (!el) return

    el.focus()
    const lines = el.value.split("\n")
    let pos = 0
    for (let i = 0; i < Math.min(lineNumber, lines.length); i++) {
      pos += lines[i].length + (i < lineNumber - 1 ? 1 : 0)
    }
    el.setSelectionRange(pos, pos)
  },

  // auto-fill targetId with slugified value from sourceId
  setupSlugField: function(sourceId, targetId, options = {}) {
    const source = document.getElementById(sourceId)
    const target = document.getElementById(targetId)
    if (!source || !target) return

    let manuallyEdited = target.value.trim() !== ""
    const self = this

    const getPrefix = () => {
      if (!options.categoryUrlMap) return ""
      const catInput = document.querySelector(options.categorySelector || "[name*=category_id]")
      if (!catInput || !catInput.value) return ""
      const catUrl = options.categoryUrlMap[catInput.value]
      return catUrl ? catUrl + "/" : ""
    }

    const updateSlug = () => {
      if (!manuallyEdited) {
        target.value = getPrefix() + self.slugify(source.value)
      }
    }

    target.addEventListener("input", () => { manuallyEdited = true })
    source.addEventListener("input", updateSlug)

    // aktualizuj URL przy zmianie kategorii
    if (options.categorySelector) {
      const catInput = document.querySelector(options.categorySelector)
      if (catInput) catInput.addEventListener("change", updateSlug)
    }
  },

  // wyświetla notyfikację flash (success/error/warning)
  notify: function(message, type) {
    const el = document.getElementById("notification_flash")
    if (!el) return

    const icons = {
      error: "<svg class=\"h-6 w-6 text-red-500\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z\"/></svg>",
      warning: "<svg class=\"h-6 w-6 text-yellow-500\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z\"/></svg>",
    }
    const icon = icons[type] || "<svg class=\"h-6 w-6 text-green-400\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z\"/></svg>"

    el.innerHTML = "<div data-controller=\"notification\" aria-live=\"assertive\" style=\"z-index:100\" class=\"fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start\"><div class=\"w-full flex flex-col self-end items-center space-y-4 sm:items-end\"><div class=\"max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1/5 ring-black overflow-hidden\"><div class=\"p-4\"><div class=\"flex items-start\"><div class=\"shrink-0\">" + icon + "</div><div class=\"ml-3 w-0 flex-1 pt-0.5\"><p class=\"text-sm font-medium text-gray-900\">" + message + "</p></div></div></div></div></div></div>"
  },

  // POST /account/set_field z feedbackiem
  // IntumJs.setField("key", value, { check: this })           — fajka obok elementu (domyślne gdy wywołane z onchange)
  // IntumJs.setField("key", value, { check: false })          — bez fajki
  // IntumJs.setField("key", value, { notify: "Zapisano" })    — notyfikacja flash (wyłącza fajkę)
  // IntumJs.setField("key", value, { target: "account" })     — zapis do account (domyślnie user_setting)
  setField: function(key, value, options) {
    const target = (options && options.target) || "user_setting"
    const url = "/account/set_field?target=" + encodeURIComponent(target) + "&key=" + encodeURIComponent(key) + "&value=" + encodeURIComponent(value)
    const csrfToken = document.querySelector("meta[name=csrf-token]")
    // domyślnie kręciołek, chyba że podano notify lub check: false
    const el = options && options.notify ? null : (options && options.check !== undefined ? options.check : (event && event.target) || null)
    let spinner

    // spinner obok elementu podczas zapisu
    if (el) {
      spinner = el.parentNode.querySelector(".intum-field-status")
      if (!spinner) {
        spinner = document.createElement("span")
        spinner.className = "intum-field-status ml-2 inline-flex items-center"
        el.insertAdjacentElement("afterend", spinner)
      }
      spinner.innerHTML = "<svg class=\"animate-spin h-4 w-4 text-gray-400\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><circle class=\"opacity-25\" cx=\"12\" cy=\"12\" r=\"10\" stroke=\"currentColor\" stroke-width=\"4\"></circle><path class=\"opacity-75\" fill=\"currentColor\" d=\"M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z\"></path></svg>"
    }

    fetch(url, { method: "POST", headers: { "X-CSRF-Token": csrfToken && csrfToken.content } })
      .then(function() {
        if (el) {
          spinner.innerHTML = "<svg class=\"h-4 w-4 text-green-700\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z\" clip-rule=\"evenodd\"/></svg>"
        }
        if (options && options.notify) window.IntumJs.notify(options.notify)
      })
  },

  // Przełączanie tabów — użycie: onclick="IntumJs.switchTab('tab_id', this)"
  switchTab: function(tabId, btn) {
    const attr = btn.closest("nav").dataset.tabGroup || "data-tab"
    document.querySelectorAll("[" + attr + "]").forEach(function(el) { el.classList.add("hidden") })
    document.getElementById(tabId).classList.remove("hidden")
    btn.closest("nav").querySelectorAll("button").forEach(function(b) {
      b.classList.remove("border-blue-500", "text-blue-600")
      b.classList.add("border-transparent", "text-gray-500")
    })
    btn.classList.add("border-blue-500", "text-blue-600")
    btn.classList.remove("border-transparent", "text-gray-500")
  },

  // Modal dodawania źródła — krok 2: pokaż elementy wybranego typu
  showAddSourceStep2: function(sourceType) {
    document.getElementById("add_source_step1").classList.add("hidden")
    document.getElementById("add_source_step2").classList.remove("hidden")
    document.querySelectorAll(".add-source-item").forEach(function(el) {
      el.classList.toggle("hidden", el.dataset.sourceType !== sourceType)
    })
  },

  showAddSourceStep1: function() {
    document.getElementById("add_source_step2").classList.add("hidden")
    document.getElementById("add_source_step1").classList.remove("hidden")
  },

  copyMarkdown: function(url, el, copiedText) {
    fetch(url, { headers: { Accept: "text/markdown" } })
      .then(r => r.text())
      .then(t => {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(t)
        } else {
          const ta = document.createElement("textarea")
          ta.value = t
          ta.style.position = "fixed"
          ta.style.opacity = "0"
          document.body.appendChild(ta)
          ta.select()
          document.execCommand("copy")
          document.body.removeChild(ta)
        }
        const target = el.querySelector("span") || el
        const original = target.textContent
        target.textContent = copiedText || "Skopiowano..."
        setTimeout(() => { target.textContent = original }, 1500)
      })
  }
}

// hotkeys("ctrl+K", (event, _handler) => {
//   event.preventDefault()
//   toggleSearch()
//   // alert(12)
//   // const archiveAndNextBtn = document.getElementById("archive_and_next")
//   // if (archiveAndNextBtn) {
//   //   archiveAndNextBtn.click()
//   // }
// })

// Globalny spinner na submit buttonach — po wysłaniu formularza disabluje button i dodaje animację
function disableSubmitButton(btn) {
  btn.disabled = true
  btn.classList.add("opacity-50", "cursor-not-allowed")
  if (btn.tagName === "BUTTON" && !btn.querySelector(".submit-spinner")) {
    // Ukryj tekst i nałóż spinner absolutnie — bez zmiany rozmiaru buttona
    btn.style.position = "relative"
    Array.from(btn.childNodes).forEach(c => {
      if (c.nodeType === 1) c.style.visibility = "hidden"
      else if (c.nodeType === 3 && c.textContent.trim()) {
        const wrap = document.createElement("span")
        wrap.style.visibility = "hidden"
        c.parentNode.insertBefore(wrap, c)
        wrap.appendChild(c)
      }
    })
    const spinner = document.createElement("span")
    spinner.className = "submit-spinner animate-spin"
    spinner.style.cssText = "position:absolute;inset:0;display:flex;align-items:center;justify-content:center"
    spinner.innerHTML = '<svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>'
    btn.appendChild(spinner)
  }
}

document.addEventListener("submit", (e) => {
  const form = e.target
  if (form.dataset.noSpinner) return
  const buttons = form.querySelectorAll('button[type="submit"], input[type="submit"]')
  buttons.forEach(disableSubmitButton)
  // Obsługa górnego buttona poza formularzem
  document.querySelectorAll(".button_save_top").forEach(disableSubmitButton)
})
